import { Component, createRef } from 'react';
import scrollTo from '../../services/scroll';
import iconScroll from '../../icons/scroll-arrow.svg';
import { debounce } from 'lodash';

class ScrollToTop extends Component {
  constructor(props) {
    super(props);
    this.scrollRef = createRef();
  }

  componentDidMount() {
    window.onscroll = debounce(this.scrollHandler, 20).bind(this);
    this.scrollRef.current.style.visibility = 'hidden';
  }

  scrollHandler = () => {
    if (this.scrollRef.current) {
      if (window.pageYOffset >= 20) {
        this.scrollRef.current.style.visibility = 'visible';
      } else {
        this.scrollRef.current.style.visibility = 'hidden';
      }
      if (document.documentElement.clientHeight + document.documentElement.scrollTop > document.documentElement.scrollHeight - 60) {
        this.scrollRef.current.classList.add('at-bottom');
      } else {
        this.scrollRef.current.classList.remove('at-bottom');
      }
    }
  };

  render() {
    return (
      <span ref={this.scrollRef} className='back-to-top' onClick={() => scrollTo('#page-wrapper')}>
        <img src={iconScroll} alt='' />
      </span>
    );
  }
}

export default ScrollToTop;
